
/**
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 *
 * @link https://github.com/Automattic/_s/blob/master/js/navigation.js
 */
(function () {
    const siteNavigation = document.getElementById('nav-main');

    // Return early if the navigation doesn't exist.
    if (!siteNavigation) {
        return;
    }

    const button = siteNavigation.getElementsByTagName('button')[0];

    // Return early if the button doesn't exist.
    if ('undefined' === typeof button) {
        return;
    }

    const menu = siteNavigation.getElementsByTagName('ul')[0];

    // Hide menu toggle button if menu is empty and return early.
    if ('undefined' === typeof menu) {
        button.style.display = 'none';
        return;
    }

    if (!menu.classList.contains('nav-menu')) {
        menu.classList.add('nav-menu');
    }

    // Toggle the .toggled class and the aria-expanded value each time the button is clicked.
    button.addEventListener('click', () => {
        console.log('click');
        siteNavigation.classList.toggle('toggled');

        if (button.getAttribute('aria-expended') === 'true') {
            button.setAttribute('aria-expended', 'false');
        } else {
            button.setAttribute('aria-expended', 'true');
        }
    });

    // Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation.
    document.addEventListener('click', (event) => {
        const isClickInside = siteNavigation.contains(event.target);

        if (!isClickInside) {
            siteNavigation.classList.remove('toggled');
            button.setAttribute('aria-expended', 'false');
        }
    });
})();


/** Ouvrir/fermer les questions de la FAQ */
const answers = document.querySelectorAll(".accordion");
answers.forEach((event) => {
    event.addEventListener("click", () => {
        const isCurrentlyActive = event.classList.contains('active');

        answers.forEach((answer) => {
            answer.classList.remove('active');
        });

        if (!isCurrentlyActive) {
            event.classList.add('active');
        }
    });
});


/** Ajouter/supprimer une classe en fonction de l'état du header (sticky ou non) */
const header = document.querySelector("#main-header");
if (header) {
    const observer = new IntersectionObserver(
        ([e]) => e.target.classList.toggle("is-sticky", e.intersectionRatio < 1),
        { threshold: [1] }
    );

    observer.observe(header);
}

/** Afficher/cacher le formulaire de code promo dans le panier */
const cartForm = document.querySelectorAll('.article-body > .woocommerce')[0];
if (cartForm) {
    cartForm.addEventListener("click", (e) => {
        if (e.target.id !== "toggle-coupon-form") {
            return;
        }

        e.preventDefault();

        const couponForm = document.querySelectorAll(".coupon")[0];
        couponForm.classList.toggle("active");
    });
}

/** Obfuscation des liens */
const obfuscatedLinks = document.querySelectorAll(".ob-link");
obfuscatedLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
        const encodedHref = link.dataset.href;
        const href = b64DecodeUnicode(encodedHref);
        const blank = link.getAttribute('target') === '_blank' ? true : false;

        window.open(href, blank ? '_blank' : '_self');
    });
});

/**
 * Décode une chaine de caractères en base64 avec caractères spéciaux
 *
 * @see https://stackoverflow.com/a/30106551
 * @param {string} base64Text encoded text
 * @returns string decoded text
 */
function b64DecodeUnicode(base64Text) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(atob(base64Text).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
}